import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { singleOrderDetails } from '../../../../../@store/orders/orders.model';
import { SafeAny } from '../../../../../types/safe-any';

@Component({
  selector: 'ciwc-order-shipping-view',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatAnchor, DatePipe],
  templateUrl: './order-shipping-view.component.html',
  styleUrls: ['./order-shipping-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderShippingViewComponent implements OnInit, OnChanges {
  @Input() orderDetails!: singleOrderDetails;

  order: SafeAny = signal(null);

  ngOnInit(): void {
    this.order.set(this.orderDetails);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderDetails']) {
      this.order.set(this.orderDetails);
    }
  }
}
